import {
  psaCompanies,
  psaAvailableProjects,
  psaProjectPhases,
  psaProjectTickets,
  psaCompanySearch,
} from "./psaV2Browser";

/**
 * Publishes the v2 PSA lookups for the server-rendered Push-to-PSA form.
 *
 * That page is HAML with inline jQuery, so it cannot import a module. The
 * `application` pack is on every page via layouts/_core_head, which makes it
 * the one place both the React roots and the legacy form can share -- and
 * sharing matters, because these calls go through the same cached OAuth token.
 */
export const registerPsaV2 = (target: any = window) => {
  target.ScopeStack = target.ScopeStack || {};
  target.ScopeStack.psa = {
    companies: psaCompanies,
    availableProjects: psaAvailableProjects,
    projectPhases: psaProjectPhases,
    projectTickets: psaProjectTickets,
    companySearch: psaCompanySearch,
  };
  return target.ScopeStack.psa;
};
